export default [{
	prop: 'goodsCode',
	label: '品项编码',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsName',
	label: '品项名称',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsSpec',
	label: '品项规格',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'goodsUnit',
	label: '品项单位',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'orderNumSum',
	label: '订货数量合计',
	width: '120',
	ischoose: true,
	align: 'center'
}]
